export default {
  role: 'Role',
  roles: 'Roles',
  verbose_role: 'a role',
  modules: 'Modules',
  general_info: 'General information',
  userrights_listing: 'Permissions list'
};
